module.exports = __webpack_public_path__ + "h5/img/integer_filter_icon.1c6ad6a4.png";